/**
 * Pentavite cart sync bridge.
 *
 * Apps like BOGOS Free Gift add the chosen gift with their own request, so the
 * theme never learns about the change and the drawer / cart icon stay stale
 * until the shopper reloads the page. This watches the cart while the mini cart
 * is open and asks the theme to re-render its cart sections when something
 * changed outside of the theme.
 */
(function () {
  if (window.pvCartSyncReady) return;
  window.pvCartSyncReady = true;

  var POLL_MS = 1500;
  var lastKey = null;
  var busy = false;

  function cartKey(cart) {
    var items = (cart.items || [])
      .map(function (item) { return item.key + ':' + item.quantity; })
      .join('|');
    return cart.item_count + '|' + cart.total_price + '|' + items;
  }

  function miniCartStore() {
    try {
      return window.Alpine ? window.Alpine.store('xMiniCart') : null;
    } catch (error) {
      return null;
    }
  }

  // Remember when the theme refreshes its own cart so we never re-render twice
  // for the same change.
  function patchThemeReload() {
    var store = miniCartStore();
    if (!store || typeof store.reLoad !== 'function' || store.pvCartSyncPatched) return;
    var original = store.reLoad.bind(store);
    store.reLoad = function () {
      window.pvCartSyncLastReload = Date.now();
      return original();
    };
    store.pvCartSyncPatched = true;
  }

  function refresh() {
    window.pvCartSyncLastReload = Date.now();
    var store = miniCartStore();
    if (store && typeof store.reLoad === 'function') store.reLoad();
    try {
      document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
    } catch (error) {}
  }

  function check() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var key = cartKey(cart);
        if (lastKey !== null && key !== lastKey) {
          var sinceReload = Date.now() - (window.pvCartSyncLastReload || 0);
          if (sinceReload > POLL_MS) refresh();
        }
        lastKey = key;
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function tick() {
    patchThemeReload();
    if (document.visibilityState === 'hidden') return;
    var store = miniCartStore();
    if (store && store.open) check();
  }

  check();
  window.setInterval(tick, POLL_MS);
  window.addEventListener('focus', check);
})();
